import isPlainObject from "lodash/isPlainObject";

export default function mapToObject(aMap) {

    let obj = {};

    if (isPlainObject(aMap)) {
        obj = {...aMap};
    }

    if (typeof aMap.forEach === 'function') {
        aMap.forEach((v, k) => {
            obj[k] = v
        });
    }

    return obj;
}
